import React from "react";
import { connect } from "react-redux";
import history from "../../history";
import { Action, authenticate } from "../../react-cognito";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import { getCurrentUser, updateLoginRecord } from "../../actions/user";
import Checkbox from '@material-ui/core/Checkbox';

import moment from "moment";
const $ = window.$;
class Login extends React.Component {
  static propTypes = {
    // cookies: instanceOf(Cookies).isRequired
  };

  constructor(props, context) {
    super(props);
    this.state = {
      email: props.email,
      username: props.username,
      error: "",
      password: "",
      loading: false,
      passwordForget: false,
      resetEmail: "",
      remember: false
    };

    this.handleChange = fieldName => event => {
      let obj = Object.assign({});
      obj[fieldName] = event.target.value;
      this.setState(obj);
    };
  }

  // loadFromUrl = () => {
  //     const split_1 = window.location.hostname.split('.')[0];
  // const split_2 = window.location.hostname.split('.')[1];
  //     this.props.getCurrentPetShop(split_1);
  // }
  // componentWillMount = () => {
  //     this.loadFromUrl();
  // }

  componentWillReceiveProps = nextProps => {
    // if(nextProps.currentUser === false) {
    //     NotificationManager.error("You don't have an account associated with this pet shop");
    // }
    if (nextProps.currentUserError !== this.props.currentUserError) {
      NotificationManager.error("Login Failed!");
    }
    if (nextProps.currentUser !== this.props.currentUser) {
      if (nextProps.currentUser) {
        if (nextProps.currentUser.UserPetstores[0].status === "Active") {
          history.push("/");
          const login = {
            date: moment(),
            user: nextProps.currentUser
          };
          this.props.updateLoginRecord(login);
        } else {
          NotificationManager.error(
            "Your account is deactivated. Please contact the admin"
          );
        }
      }
    }
  };

  onSubmit = event => {
    event.preventDefault();
    const {username, remember} = this.state;    
    if(username !== '') {
      localStorage.setItem('remember', remember);
      localStorage.setItem('username', remember ? username : '');
    }
    this.setState({ loading: true });
    this.props
      .onSubmit(username, this.state.password)
      .then(() => {
        this.setState({ loading: false });
        if (this.props.cognitoState === "CONFIRMATION_REQUIRED") {
          NotificationManager.info("Please Confirm your account");
          history.replace("/confirm");
        } else {
          if (this.props.cognitoState === "AUTHENTICATED") {
            this.props.getCurrentUser(this.props.username);
          }
        }
      })
      .catch(error => {
        this.setState({ loading: false });
        //console.dir(error)
        console.dir();
        NotificationManager.error(error.message);
      });
  };

  changeUsername = event => {
    this.setState({ username: event.target.value });
  };

  changePassword = event => {
    this.setState({ password: event.target.value });
  };

  changeRememberMe = event => {
    this.setState({ remember : event.target.checked });
  };

  onChangePassword(action) {
    if (action == "enable") {
      this.setState({ passwordForget: true });
    } else if ("disable") {
      this.setState({ passwordForget: false });
    }
  }

  onCapthcaSuccess() {
    this.setState({
      captchaSuccess: true
    });
  }

  submitChangePassword() {
    this.props
      .sendVerificationCode(this.state.resetEmail, this.props.userPool)
      .then(res => {
        NotificationManager.success("Reset Password Instruction Sent");
        this.setState({
          loading: false,
          resetEmail: ""
        });
      })
      .catch(err => {
        NotificationManager.success("Reset Password Error");
        this.setState({
          loading: false,
          resetEmail: ""
        });
      });
  }

  componentDidMount() {
    const remember = localStorage.getItem('remember') === 'true';
    const username = remember ? localStorage.getItem('username') : '';
    this.setState({ username, remember });
  }

  render() {
    const { classes, theme, petShop } = this.props;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div
          className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2"
          id="m_login"
          style={{
            backgroundImage:
              "url(../../../assets/app/media/img/bg/new-background.png)"
          }}
        >
          <div className="m-grid__item m-grid__item--fluid m-login__wrapper">
            <div className="m-login__container">
              <div className="m-login__logo">
                {/* <a href="#"> */}
                {petShop.currentPetshop && (
                  <img
                    src={
                      petShop.currentPetshop.logo_path
                        ? process.env.REACT_APP_S3_PATH +
                          "/" +
                          petShop.currentPetshop.logo_path
                        : "../../../assets/app/media/img/logos/petpos-logo2.png"
                    }
                    style={{ maxHeight: "150px" }}
                    className="mw-100"
                  />
                )}

                {/* </a> */}
              </div>

              <div className="m-login__signin">
                <div className="m-login__head">
                  <h3 className="m-login__title">Sign In To Pet Store</h3>
                </div>
                <form
                  className="m-login__form m-form"
                  onSubmit={this.onSubmit}
                  noValidate
                  autoComplete="off"
                >
                  <div className="form-group m-form__group">
                    <input
                      value={this.state.username}
                      onChange={this.changeUsername}
                      className="form-control m-input"
                      type="text"
                      placeholder="Username"
                      name="username"
                    />
                  </div>
                  <div className="form-group m-form__group">
                    <input
                      autoComplete="current-password"
                      onChange={this.changePassword}
                      className="form-control m-input m-login__form-input--last"
                      type="password"
                      placeholder="Password"
                      name="password"
                    />
                  </div>
                  <div className="row m-login__form-sub">
                    <div className="col m--align-left m-login__form-left">
                      <label className="m-checkbox">
                      {/* <Checkbox
                        checked={this.state.remember}
                        onChange={this.changeRememberMe}
                        value="remember"
                        inputProps={{
                          'aria-label': 'secondary checkbox',
                        }}
                      /> */}
                        <input type="checkbox" name="remember" onChange={this.changeRememberMe} checked={this.state.remember}/>
                        Remember me
                        <span></span>
                      </label>
                    </div>
                    <div className="col m--align-right m-login__form-right">
                      <a
                        onClick={() => history.push(`/forgot-password`)}
                        href="javascript:;"
                        id="m_login_forget_password"
                        className="m-link"
                      >
                        Forget Password ?
                      </a>
                    </div>
                  </div>
                  <div className="m-login__form-action">
                    {this.state.loading == false ? (
                      <button
                        type="submit"
                        id="m_login_signin_submit"
                        className="btn btn-success m-btn m-btn--pill m-btn--custom m-btn--air  m-login__btn"
                      >
                        Sign In
                      </button>
                    ) : (
                      <Loader
                        type="line-scale"
                        active={true}
                        className="float-right"
                      />
                    )}
                  </div>
                </form>
                {/* <div className="m-login__account">
                    <span className="m-login__account-msg">
                        Don't have an account yet ?
                    </span>
                    &nbsp;&nbsp;
                    <a href="javascript:;" id="m_login_signup" className="m-link m-link--light m-login__account-link">
                        Sign Up
                    </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      // <div className="col-12 auth-outer">
      //     <form onSubmit={this.onSubmit}>
      //         <div className="login-wrapper">
      //             <div className="login-fields">
      //                 <h3>Login</h3>
      //                 <TextField
      //                     id="name"
      //                     value={this.state.username}
      //                     onChange={this.changeUsername}
      //                     label="Username"
      //                     fullWidth={true}
      //                 />
      //                 <TextField
      //                     id="pass"
      //                     onChange={this.changePassword}
      //                     label="Password"
      //                     type="password"
      //                     fullWidth={true}
      //                 />
      //                 <br />
      //                 <br />
      //                 <Capthca
      //                     onCapthcaSuccess={() => this.onCapthcaSuccess()}
      //                 />
      //                 <div className="pull-right" style={{ margin: 10 }}>
      //                     <Link to="register">Register</Link>
      //                 </div>
      //                 <div className="pt20">
      //                     {this.state.loading == false &&
      //                         <Button type="submit" raised disabled={!this.state.captchaSuccess} fullWidth={true}> Log In </Button>
      //                     }
      //                     {this.state.loading == true &&
      //                         <Loader type="line-scale" active={this.state.loading} className="text-center" />
      //                     }
      //                 </div>
      //             </div>
      //         </div>
      //     </form>
      // </div>
    );
  }
}

const mapStateToProps = state => {
  let username = "";
  if (state.cognito.user) {
    username = state.cognito.user.getUsername();
  } else if (state.cognito.userName) {
    username = state.cognito.cache.userName;
  }
  return {
    username,
    cognitoState: state.cognito.state,
    email: state.cognito.cache.email,
    config: state.cognito.config,
    userPool: state.cognito.userPool,
    user: state.cognito.user,
    currentUser: state.userReducer.currentUser,
    currentUserError: state.userReducer.currentUserError,
    petShop: state.petShopReducer
  };
};

const mapDispatchToProps = dispatch => ({
  authenticator: (username, password, userPool, config) =>
    authenticate(username, password, userPool, config, dispatch),
  clearCache: () => dispatch(Action.clearCache()),
  getCurrentUser: un => {
    dispatch(getCurrentUser(un));
  },
  updateLoginRecord: data => {
    dispatch(updateLoginRecord(data));
  }
  // getCurrentPetShop: (title) => {
  //     dispatch(getCurrentPetShop(title));
  // }
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, ownProps, stateProps, {
    onSubmit: (username, password) =>
      dispatchProps.authenticator(
        username,
        password,
        stateProps.userPool,
        stateProps.config
      ),
    clearCache: dispatchProps.clearCache,
    // getCurrentPetShop:(title) => dispatchProps.getCurrentPetShop(title),
    getCurrentUser: un => dispatchProps.getCurrentUser(un),
    updateLoginRecord: data => dispatchProps.updateLoginRecord(data)
  });

/**
 * Container for login behaviour, wrapping a login form.
 *
 * Magically provides the following props to the wrapped form:
 *
 *  * username
 *  * onSubmit
 *
 * @example
 * <Login>
 *   <LoginForm />
 * </Login>
 */

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Login);
